class d extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.sliderTrack = this.querySelector("simple-slider-track"), this.slides = this.querySelectorAll("simple-slide"), this.indicator = this.querySelector("simple-slider-indicator"), !this.sliderTrack || !this.slides.length)
      return;
    const t = this.dataset.next, e = this.dataset.prev;
    !t || !e || (this.next = document.querySelector(t), this.prev = document.querySelector(e), !(!this.next || !this.prev) && this.observeSelf());
  }
  observeSelf() {
    const t = {
      root: null,
      threshold: 0.1
    }, e = new IntersectionObserver((s) => {
      s.forEach((i) => {
        i.isIntersecting && (this.init(), e.disconnect());
      });
    }, t);
    e.observe(this);
  }
  observeSlides() {
    const t = {
      root: this.sliderTrack,
      threshold: 0.5
    }, e = new IntersectionObserver((s) => {
      s.forEach((i) => {
        var a, o, n, c;
        const l = Array.from(this.slides).indexOf(
          i.target
        );
        i.isIntersecting && (this.updateIndicator(l), this.replaceState(l + 1)), l === 0 && (i.isIntersecting ? (this.dataset.progress = "start", (a = this.prev) == null || a.setAttribute("aria-disabled", "true")) : (this.dataset.progress = "", (o = this.prev) == null || o.removeAttribute("aria-disabled"))), l === this.slides.length - 1 && (i.isIntersecting ? (this.dataset.progress = "end", (n = this.next) == null || n.setAttribute("aria-disabled", "true")) : (this.dataset.progress = "", (c = this.next) == null || c.removeAttribute("aria-disabled")));
      });
    }, t);
    this.slides.forEach((s) => e.observe(s));
  }
  updateIndicator(t) {
    if (!this.indicator)
      return;
    this.indicator.querySelectorAll("[data-bullet]").forEach((s, i) => {
      s.classList.remove("active"), i === t && s.classList.add("active");
    });
  }
  init() {
    if (this.checkScroll(), this.slideSize = this.slides[0].getBoundingClientRect().width, this.hasAttribute("autoplay")) {
      if (this.autoplay = parseInt(this.getAttribute("autoplay") || "0"), !this.autoplay)
        return;
      this.autoplayProcess = setInterval(() => {
        if (this.dataset.progress === "end") {
          this.slideTo(1);
          return;
        }
        this.slide();
      }, this.autoplay);
    }
    if (window.addEventListener("resize", () => {
      this.slideSize = this.slides[0].getBoundingClientRect().width, this.checkScroll();
    }), window.location.hash && this.querySelector(window.location.hash)) {
      const t = this.querySelector(window.location.hash);
      t && t.scrollIntoView();
    }
    this.observeSlides();
  }
  get scrollable() {
    var t, e;
    return this.sliderTrack && this.sliderTrack.scrollWidth ? ((t = this.sliderTrack) == null ? void 0 : t.scrollWidth) > ((e = this.sliderTrack) == null ? void 0 : e.clientWidth) : !1;
  }
  checkScroll() {
    var t, e, s, i;
    this.scrollable ? (this.dataset.scrollable = "true", (t = this.next) == null || t.removeAttribute("hidden"), (e = this.prev) == null || e.removeAttribute("hidden")) : (this.dataset.scrollable = "false", (s = this.next) == null || s.setAttribute("hidden", ""), (i = this.prev) == null || i.setAttribute("hidden", ""));
  }
  slide(t = !1) {
    var s;
    this.slideSize = this.slides[0].getBoundingClientRect().width;
    const e = t ? -1 : 1;
    (s = this.sliderTrack) == null || s.scrollBy({
      left: this.slideSize * e,
      behavior: "smooth"
    });
  }
  slideTo(t) {
    var l, a;
    this.slideSize = this.slides[0].getBoundingClientRect().width;
    const e = t - 1, s = ((l = this.sliderTrack) == null ? void 0 : l.scrollLeft) || 0, i = this.slideSize * e;
    (a = this.sliderTrack) == null || a.scrollBy({
      left: i - s,
      behavior: "smooth"
    });
  }
  replaceState(t) {
    const e = window.location.hash;
    if (!e || !this.querySelector(e))
      return;
    const i = e.replace(/\d+$/, t.toString());
    window.history.replaceState({}, "", i);
  }
}
window.customElements.define("simple-slider", d);
document.addEventListener("click", (r) => {
  const t = document.getElementById(
    r.target.dataset.sliderId
  );
  if (!(!t || !r.target) && (r.target.classList.contains("swiper-button-prev") && (t.slide(!0), clearInterval(t.autoplayProcess)), r.target.classList.contains("swiper-button-next") && (t.slide(), clearInterval(t.autoplayProcess)), r.target instanceof Element && r.target.hasAttribute("data-bullet"))) {
    if (!t.indicator)
      return;
    const e = t.indicator.querySelectorAll("[data-bullet]"), s = Array.from(e).indexOf(r.target);
    t.slideTo(s + 1), clearInterval(t.autoplayProcess);
  }
});
export {
  d as SimpleSlider
};
